import { compute } from '@exodus/atoms'
import { FiatOrderSet } from '@exodus/models'

const createFiatOrdersNeedsUpdateAtom = ({ fiatOrdersAtom }) => {
  const selector = (value) =>
    FiatOrderSet.fromArray(
      [...value].filter((order) => ['in-progress', 'syncing'].includes(order.exodusStatus))
    )

  return compute({ atom: fiatOrdersAtom, selector })
}

const fiatOrdersNeedsUpdateAtomDefinition = {
  id: 'fiatOrdersNeedsUpdateAtom',
  type: 'atom',
  factory: createFiatOrdersNeedsUpdateAtom,
  dependencies: ['fiatOrdersAtom'],
  public: true,
}

export default fiatOrdersNeedsUpdateAtomDefinition
